import Moment from 'moment-timezone';
import React, { PureComponent } from 'react';
import { CSVLink } from 'react-csv';
import { Button, Cell, Divider, Grid, SelectField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
//import { HorizontalBar } from 'react-chartjs-2'
import ApiRequestService from '../component/ApiRequestService';
import ClusteredBarChart from '../component/ClusteredBarChart';
import LoadingSpinner from '../component/LoadingSpinner';
import { AppSetting, AppProperties } from '../common/function';



  

const loaderColor = '#bb0000';

/* const getCategoryAccuracyLabel = (tooltipItem, data) => {
    var label = data.datasets[tooltipItem.datasetIndex].label || '';
  
    if (label) {
        label += ': ';
    }
    label += Math.round(tooltipItem.yLabel * 100) / 100;
  
    return "Completion Accuracy :"+label;
  }

  const getCategoryAttemptLabel = (tooltipItem, data) => {
    var label = data.datasets[tooltipItem.datasetIndex].label || '';
  
    if (label) {
        label += ': ';
    }
    label += Math.round(tooltipItem.yLabel * 100) / 100;
  
    return "Attempt Time :"+label;
  }
 */
export default  class PerfChart extends PureComponent {
    AppSetting = AppSetting()
    appProperties =  AppProperties();
    constructor(props){
        super(props);
        this.state = {
            hideCategoryDropDown:true,
            isCategoryLoading:false,
            isGraphLoading:false,
            hideGraphs:true,
            courses:[],
            categories:[],
            graphData:{studentCategoryAccuracy:{},studentCategoryAttemptTime:{}},
            selectedCourseID:0,
            selectedCatID:0,
            students:[],
            userName:window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
            userRole:false,
            categoryStat:{},
            loading:true,
            isCoursesLoading:true,
            isGetGradedCategoryStatLoading:false,
            firstAttemptColor : [],
            lastAttemptColor :[],
            isStudentLoading:false,
            allStudentGradStat:{},
            sectionList:[],
            selectedSectionID:0,
            showCSVdownload:false,
            csvAllStudentMean:null,
            selectedStudentID : "allStudents",
            showStudent:false,
            showSection:false,
            isSectionLoading:true,
            showCourse:false,
            selectedSemseterID:undefined,
            isSemesterLoading:false
        }
        this.getGradedCategoryStat = this.getGradedCategoryStat.bind(this);
        
    }

    componentWillMount(){
        if(!this.props.archiveMode){
            this.setState({
                showCourse:true
            })
        this.getInstructorCourses();
        }
       // this.getAllStudents();
        this.setState({userRole:true});
        //this.getEnrolledCourses();
    }

    onSemesterChange = (semester) => {
        this.setState({
            selectedSemesterID:semester.id,
            showSection:false,
            showStudent:false,
            isSectionLoading:true,
            hideGraphs:true,
            showCSVdownload:false,
            isCoursesLoading:true,
            showCourse:true,
        });        
      //  this.getCategoryByCourseID(course.course_id);
        this.getAllCoursesForSemester(semester.id)
    }

    
    getAllCoursesForSemester = (semId) =>{
        console.debug("in getAllCoursesForSemester")
        var payload = {
            id : semId
        }
        ApiRequestService({
                url:'/getAllCoursesForSemester',
                method:'post',
                data:payload
              }).then(res => {
                if(res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null){
                    if(res.data.status === 0){
                        this.setState({
                            courses:res.data.data.course_names,
                            isCoursesLoading:false
                        });
                         console.debug("in getAllCoursesForSemester",res.data)                         
                        }else{
                            NotificationManager.error("error",res.data.message,5000);
                        }
                    }else{
                        NotificationManager.error("No Courses");
                    }
            }).catch(error => {
                NotificationManager.error("Get courses Failed  : "+error,"ERROR",2000)
            });
    }

    onCourseChange = (course) => {
        this.setState({students:[],
            selectedCourseID:course.course_id,
            selectedStudentID:"allStudents",
            showSection:true,
            showStudent:false,
            isSectionLoading:true,
            hideGraphs:true,
            showCSVdownload:false,
        });        
      //  this.getCategoryByCourseID(course.course_id);
        this.getUserSectionForCourses(course.course_id)
    }

    onSectionChange = (section) =>{
        console.debug("selected section is",section)
        this.setState({
            selectedSectionID:section.section_id,
            isStudentLoading:true});
        if(section.section_name === "All Sections"){
            //this.getAllStudentGradedStat()
        }else{
            this.getAllStudents(section.course_id,section.section_id);
        }
        //this.getStudentEnrolledCourses(student);
        
    }

    onStudentChange = (student) =>{
        //console.debug("selected student is",student.student_name,student.user_name)
        this.setState({selectedStudentID:student.user_name});
        if(student.user_name === "allStudents"){
            this.getAllStudentGradedStat()
        }else{
            this.getGradedCategoryStat(student.user_name);                
        }
        //this.getStudentEnrolledCourses(student);
        
    }


    getInstructorCourses = () =>{
        console.debug("in getInstructorCourses")
        ApiRequestService({
                url:'/getAllCourses',
                method:'post'
              }).then(res => {
                if(res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null){
                    if(res.data.status === 0){
                        this.setState({
                            courses:res.data.data.course_names,
                            isCoursesLoading:false
                        });
                         console.debug("in getInstructorCourses",res.data)                         
                        }else{
                            NotificationManager.error("error",res.data.message,5000);
                        }
                    }else{
                        NotificationManager.error("No Courses");
                    }
            }).catch(error => {
                NotificationManager.error("Get courses Failed  : "+error,"ERROR",2000)
            });
    }

    getAllStudentGradedStat = () =>{
        this.setState({isGetGradedCategoryStatLoading:true});        
        console.debug("in getAllStudentGradedStatMean")
        ApiRequestService({
                url:'/getAllStudentGradedStatMean',
                method:'post',
                data:{
                    courseID : this.state.selectedCourseID,
                    sectionID : this.state.selectedSectionID
                }
              }).then(res => {
                if(res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null){
                    if(res.data.status === 0){
                        let firstAttemptColor = []
                        let lastAttemptColor =[]
                        firstAttemptColor = this.settingColor(res.data.data.first_attempt_accuracy)
                        lastAttemptColor = this.settingColor(res.data.data.last_attempt_accuracy)
                        console.debug(lastAttemptColor)
                         this.setState({
                            csvAllStudentMean:res.data.data.all_students_mean_csv,                                                        
                            isGetGradedCategoryStatLoading:false,
                            firstAttemptColor : firstAttemptColor,
                            lastAttemptColor : lastAttemptColor,
                            categoryStat:res.data.data,
                            showCSVdownload : true});
                         console.debug("in getInstructorCourses",res.data)                         
                        }else{
                            NotificationManager.error("No Data Found.");
                            console.debug(res.data.message)
                            this.setState({
                                isGetGradedCategoryStatLoading:false,
                            })
                        }
                    }else{
                        NotificationManager.error("No Data Found.");
                        console.debug(res.data.message)
                        this.setState({
                            isGetGradedCategoryStatLoading:false,
                        })
                    }
            }).catch(error => {
                NotificationManager.error("Request Failed : "+error,"ERROR",2000)
                console.debug(error)
            });
            this.setState({hideGraphs:false});
    }

    getAllStudents =  (courseId,sectionId) => {
        this.setState({hideGraphs:true,isStudentLoading:true});
        console.debug("in getAllStudents",this.state.isStudentLoading)
        ApiRequestService({
                url:'/getInstructorsAllStudents',
                method:'post',
                data:{course_id :courseId,
                section_id : sectionId}
              }).then(res => {
                if(res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null){
                    if(res.data.status === 0){
                        if(res.data.data.length > 1){
                        //(res.data.data).unshift({student_name: "All Students", user_name: "allStudents"})                        
                         this.setState({
                             students:res.data.data,
                             isStudentLoading:false,
                             showStudent:true,            
                             selectedStudentID:res.data.data[0].user_name
                        });
                         //this.setState({selectedStudentID:res.data.data[0].user_name});
                         this.getAllStudentGradedStat()
                        }else{
                            this.setState({
                                showStudent:false  })
                            NotificationManager.error("No Student in the selected section.");
                        }
                        }else{
                            this.setState({
                                showStudent:false  })
                            NotificationManager.error("error",res.data.message,5000);
                        }
                    }
            }).catch(error => {
                NotificationManager.error("Get Student Failed Failed : "+error,"ERROR",2000)
              });            
    }

    settingColor =  (arr) =>{
        var colorArr = []
        console.debug("arr ",arr)
        if(arr !== undefined && arr !== null){
        for(let i =0 ; i <= arr.length ; i++){
           
            if(arr[i] > 80){
                colorArr[i] = "#27AE60"
            } else if (arr[i] <= 80 && arr[i] >= 60){
                colorArr[i] ="#F1C40F"
            } else {
                colorArr[i] ="#BB0000"
            }
            console.debug("arr ",arr[i],colorArr[i])
        }
    }
    colorArr.pop()
    console.debug(colorArr)
        return colorArr
    }


    getGradedCategoryStat (userId){
        this.setState({isGetGradedCategoryStatLoading:true});
        ApiRequestService({
                url:'/getGradedCategoryStat',
                method:'post',
                data:{
                    courseID:this.state.selectedCourseID,
                    UserID:userId,
                    SectionID:this.state.selectedSectionID
                }
              }).then(response => {
                if(response && response.data){
                    if(response.data.status === 0){
                        let firstAttemptColor = []
                        let lastAttemptColor =[]
                        firstAttemptColor = this.settingColor(response.data.data.first_attempt_accuracy)
                        lastAttemptColor = this.settingColor(response.data.data.last_attempt_accuracy)
                        console.debug(lastAttemptColor)
                        this.setState({
                            isGetGradedCategoryStatLoading:false,
                            firstAttemptColor : firstAttemptColor,
                            lastAttemptColor : lastAttemptColor,
                            categoryStat:response.data.data,
                            
                        });
                        console.debug("asd",firstAttemptColor,this.state.firstAttemptColor)
                    }else{
                        NotificationManager.error("error",response.data.message,5000);
                    }
                }else{
                    NotificationManager.error("error","Error - Empty Response",5000);
                }
            }).catch(error => {
                NotificationManager.error("Get Graph Failed : "+error,"ERROR",2000)
            }); 
        this.setState({hideGraphs:false});
        
    }

    getUserSectionForCourses =  (courseId) => {
        ApiRequestService({
            url:'/getUserSectionForCourses',
            method:'post',
            data:{
                    course_id : courseId
                }
            }).then(response => {
            if(response && response.data){
                if(response.data.status === 0){
                    if(response.data.data !== null && response.data.data !== undefined &&response.data.data[0] !== null){
                        //(response.data.data).unshift({section_name: "All Sections"})                                                
                        this.setState({
                            sectionList:response.data.data,
                            isSectionLoading:false
                        });
                        //this.getCategoryByCourseID(response.data.data[0].course_id);
                    }else{
                        NotificationManager.error("No Section in selected Course",response.data.message,5000);                                              
                        this.setState({
                            isSectionLoading:false,
                            showSection:false
                        });
                    }
                }else{
                    NotificationManager.error("error",response.data.message,5000);
                }
            }else{
                NotificationManager.error("error","Error - Empty Response",5000);
            }

        }).catch(error => {
            NotificationManager.error("Get Graph Failed : "+error,"ERROR",2000)
        }); 
    }
     
    render() {
       // const {studentCategoryAccuracy} = this.state.graphData;
       // const {studentCategoryAttemptTime} = this.state.graphData;
        //console.debug("students",this.state.students,this.state.userRole)
            let currentTime = Moment.tz(Date(), this.appProperties.baseFolder.timeZone || "America/New_York");        
            let csvAllStudentMeanHeaders = [
                { label: 'Category Name', key: 'category_name' },
                { label: 'Total Number Of Students First Attempt', key: 'total_number_of_student_first_attempt' },
                { label: 'Total Number Of Students Last Attempt', key: 'total_number_of_student_last_attempt' },
                { label: 'Trimmed Mean of First Attempt Accuracy', key: 'first_attempt_accuracy' },
                { label: 'Trimmed Mean of Last Attempt Accuracy', key: 'last_attempt_accuracy' },
                { label: 'Trimmed Mean of First Attempt Time', key: 'first_attempt_time' },
                { label: 'Trimmed Mean of Last Attempt Time', key: 'last_attempt_time' },
                { label: 'Standard Deviation of First Attempt Accuracy', key: 'first_attempt_accuracy_sd' },
                { label: 'Standard Deviation of Last Attempt Accuracy', key: 'last_attempt_accuracy_sd' },
                { label: 'Standard Deviation of First Attempt Time', key: 'first_attempt_time_sd' },
                { label: 'Standard Deviation of Last Attempt Time', key: 'last_attempt_time_sd' },
                           
            ]
        
        return (
            <div>
               
            <Grid //style = {{marginTop: '-65px'}}>
            >
               
                { this.props.archiveMode ? 
                <Cell size={5}>
                <label style={{paddingRight:"1em"}}>{this.appProperties.schoolMode?'Standard :':'Semester :'} </label>
                
                    <CustomDropDown 
                        placeholder={this.appProperties.schoolMode?"Select an Academic Year":"Select a Semester"}
                        id="semesterDropDown"
                        itemLabel="name"
                        itemValue="id"
                        loading={this.state.isSemesterLoading}
                        data={this.props.semesters}
                        onChange={this.onSemesterChange}
                        selectedValue={this.state.selectedSemseterID}
                    />
                </Cell>
                :
                null}
                {this.state.showCourse ?
                    <Cell size={5}>
                <label style={{paddingRight:"1em"}}>{this.appProperties.schoolMode?"Standard :":"Course :"} </label>
                
                    <CustomDropDown 
                        placeholder={this.appProperties.schoolMode?"Select a standard":"Select a Course"}
                        id="enrolledCoursesDropDown"
                        itemLabel="course_name"
                        itemValue="course_id"
                        loading={this.state.isCoursesLoading}
                        data={this.state.courses}
                        onChange={this.onCourseChange}
                        selectedValue={this.state.selectedCourseID}
                    />
                </Cell>
                :
                null
                }
                {this.state.showSection === true ? 
                <Cell size={5}>
                <label style={{paddingRight:"1em"}}>Section : </label>
                
                    <CustomDropDown 
                        placeholder="Select a Section"
                        id="enrolledSectionDropDown"
                        itemLabel="section_name"
                        itemValue="section_id"
                        loading={this.state.isSectionLoading}
                        data={this.state.sectionList}
                        onChange={this.onSectionChange}
                        selectedValue={this.state.selectedSectionID}
                    />
                </Cell>
                : ""}
                {this.state.showStudent ? 
                <Cell size={5} >
                    <label style={{paddingRight:"1em"}}>Student : </label>
                  
                    <CustomDropDown 
                        placeholder="Select a Student"
                        id="studentName"
                        itemLabel="student_name"
                        itemValue="user_name"
                        loading={this.state.isStudentLoading}
                        native={true}
                        selectedValue={this.state.selectedStudentID}
                        data={this.state.students}
                        onChange={this.onStudentChange}
                    />
                        
                </Cell>
                : ""}
               {this.state.showCSVdownload !== false && this.state.selectedStudentID === "allStudents" && this.state.csvAllStudentMean !== null && this.state.csvAllStudentMean !== undefined ?( 
                <div  style={{textAlign: "right"}}>
                    <CSVLink
                    data={this.state.csvAllStudentMean}
                    headers={csvAllStudentMeanHeaders}
                    filename={
                        'All Students Stats'+
                        '_' +
                        currentTime.format()+
                        '.csv'
                    }
                    >
                    {
                        <Button primary swapTheming raised className="buttonColour">
                        Download CSV
                        </Button>
                    }
                    </CSVLink>
                </div>   
                ) : "" }          
              <br/>
                {this.state.hideGraphs === false ?
                <Cell size={12}>
                {(this.state.isGetGradedCategoryStatLoading ===  true) ? 
                        <LoadingSpinner/> :
                    <div styel={{height:"100%"}}>                                            
                        {this.state.categoryStat !== undefined && this.state.categoryStat !== null  ? 
                        <Grid>
                            <Cell size={12} >
                                <p  style={{fontSize: "medium"}}>Attempt Accuracy(% Correct)</p>
                                <Divider className="fullWidth" />
                                <div style={{height:"1400px",width:"90%"}}>
                                    <ClusteredBarChart 
                                        color={this.state.firstAttemptColor} 
                                        color1={this.state.lastAttemptColor} 
                                        isLabel={true} 
                                        label={this.state.categoryStat.category_name} 
                                        data = {this.state.categoryStat.first_attempt_accuracy}
                                        data2={this.state.categoryStat.last_attempt_accuracy}
                                        label1={"First Attempt Accuracy"}
                                        label2={"Last Attempt Accuracy"}
                                        stepSize={20}
                                    />
                                </div>
                            </Cell>
                            <Cell size={12}>
                                <p  style={{fontSize: "medium"}}>Attempt Time(Seconds)</p>
                                <Divider className="fullWidth" />
                                <div style={{height:"1400px",width:"90%"}}>
                                    <ClusteredBarChart 
                                        color={"#1B75BC"} 
                                        color1={"#FC91AD"} 
                                        isLabel={true} 
                                        label={this.state.categoryStat.category_name} 
                                        data = {this.state.categoryStat.first_attempt_time}
                                        data2={this.state.categoryStat.last_attempt_time}
                                        label1={"First Attempt Time"}
                                        label2={"Last Attempt Time"}
                                        stepSize={0}
                                    />
                                </div>
                            </Cell>
                        </Grid >
                        : ''}
                    </div>
                }
                </Cell>
                : ''}
                </Grid>
            </div>
        );
    }
}

const CustomDropDown =(props) =>{
    const dataFull = props.data;
    
    const onChange = (_, index) => {
        props.onChange(props.data[index],index);
    }
    const onChangeNative = (event) =>{
        event.stopPropagation();
        if (event.target.value === 'nil')
            return;
        props.onChange({user_name:event.target.value},-1);
        
    }
    
    if(props.loading){
        return <BeatLoader loading={true} color={loaderColor}/>
    }
    if(props.hidden){
        return null;
    }
    
    if (props.native)
    return <span   className='native-select-box'>
    <select class="minimal"
        onChange={onChangeNative}
        value={props.selectedValue}
    >
     {
         [<option key='default' value='nil'>Select a Student</option>,
         dataFull.map(student=>{
             return <option key={student.user_name} value={student.user_name}>{student.student_name}</option>
         })]
     }   
</select></span>
    return <SelectField
                id={props.id}
                itemLabel={props.itemLabel}
                itemValue={props.itemValue}
                placeholder={props.placeholder}
                menuItems={dataFull !== undefined && dataFull !== null ? dataFull.slice(0,9) : []}
                onChange={onChange}
                value={props.selectedValue}
            />
}

